import { createFileRoute } from '@tanstack/react-router'
import TermsRuleContainer from 'Royalty/containers/TermsRuleContainer'

export const Route = createFileRoute('/royalty_/agreement/$id/terms/$ruleSetId/version/$ruleId')({
    component: TermsRuleContainer,
})
